import Button from '../../../../components/button'
import { H5, S05 } from '../../../../styles/typography'
import PricingStore from '../stores/pricing-store'

const ReceivedInvite = () => {
  const {
    invites: { received: { id, sender } = {} } = {},
    existing,
  } = PricingStore.useContainer()

  return !id || existing?.id ? null : (
    <div className='invites'>
      <div className='card'>
        <H5>You received an Offer Invite!</H5>

        <S05>
          You have received an invitation to purchase a LivDemy Subscription
          from <span>{sender}</span>. Thanks to {sender} you'll receive either{' '}
          <span>1 live class for free</span> if you purchase the{' '}
          <span>Musician plan</span>, or <span>1 month extra</span> if you
          purchase the <span>Maestro plan</span>.
        </S05>

        <Button
          theme='primary'
          onClick={() => {
            document
              ?.getElementById('plans')
              ?.scrollIntoView({ behavior: 'smooth' })
          }}
        >
          View Plans
        </Button>
      </div>
    </div>
  )
}

export default ReceivedInvite
